export const selectResult = (state) => state.tips.result;
export const selectError = (state) => state.tips.error;
export const selectLoading = (state) => state.tips.loading;
